export const fontSizeHeaderBig = {
  fontSize: { xs: "2em", md: "3em" }
};

export const fontSizeHeader = {
  fontSize: { xs: "1.5em", md: "2em" }
};

export const fontSizeSubHeader = {
  fontSize: { xs: "1.2em", md: "1.8em" }
}

export const fontSizeText = {
  fontSize: { xs: ".9em", md: "1em" }
};

export const fontSizeTextLarge = {
  fontSize: { xs: "1em", md: "1.2em" }
};

export const fontSizeTextSmall = {
  fontSize: { xs: ".8em", md: ".9em" }
};

export const fontSizeTextExtraSmall = {
  fontSize: { xs: ".7em", md: ".8em" }
};

export const colorBlack = {
  color: "black"
};

export const colorWhite = {
  color: "white"
}

export const colorPrimary = {
  color: "#FE8A01"
}

export const bgBlack = {
  background: "black"
}

export const bgWhite = {
  background: "white"
}

export const bgGray = {
  background: "#1D1D24"
}

export const bgPrimary = {
  background: "#FE8A01"
}

export const headerStyle = {
  ...fontSizeHeader,
  ...colorWhite,
  fontFamily: "'Anton', 'Outfit', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important",
  letterSpacing: "1px"
  // fontWeight: "bold",
}

export const subHeaderStyle = {
  ...fontSizeSubHeader,
  ...colorWhite,
  fontFamily: "'Anton', 'Outfit', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important",
  letterSpacing: "1px"
  // fontWeight: "bold",
}

export const subSubHeaderStyleLarge = {
  ...fontSizeTextLarge,
  ...colorWhite,
  fontFamily: "'Anton', 'Outfit', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important",
  letterSpacing: "1px"
}

export const textStyle = {
  ...fontSizeText,
  ...colorWhite
}

export const textStyleLarge = {
  ...fontSizeTextLarge,
  ...colorWhite
}

export const textSmallStyle = {
  ...fontSizeTextSmall,
  ...colorWhite
}

export const textExtraSmallStyle = {
  ...fontSizeTextExtraSmall,
  ...colorWhite
}

export const headerStyleContrast = {
  ...fontSizeHeader,
  ...colorBlack,
  fontFamily: "'Anton', 'Outfit', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important",
  letterSpacing: "1px"
}

export const subHeaderStyleContrast = {
  ...fontSizeSubHeader,
  ...colorBlack,
  fontFamily: "'Anton', 'Outfit', 'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important",
  letterSpacing: "1px"
}

export const textStyleContrast = {
  ...fontSizeText,
  ...colorBlack
}

export const textStyleLargeContrast = {
  ...fontSizeTextLarge,
  ...colorBlack
}

export const textSmallStyleContrast = {
  ...fontSizeTextSmall,
  ...colorBlack
}

export const textExtraSmallStyleContrast = {
  ...fontSizeTextExtraSmall,
  ...colorBlack
}

export const orangeHex = "#FE8A01";
export const darkGrayHex = "#171717";
export const grayHex = "#1D1D24";
export const lightgrayHex = "#505862";
export const lightergrayHex = "#828B99";
export const extraLightGray = "#f0f0f0";
export const blackHex = "#0A0A0B";
export const redHex = "#E50B0B";
export const discountHex = "#F36464";

export const checkboxStyle = {
  color: "white !important",
  "&.MuiChecked": {
    color: "white",
  },
};

export const checkboxStyleContrast = {
  color: "black",
  "&.MuiChecked": {
    color: "black",
  },
};

export const checkboxStylePrimary = {
  color: "#FE8A01",
  "&.MuiChecked": {
    color: "#FE8A01",
  },
};

export const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxWidth: "90%",
  maxHeight: "95vh",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: "12px",
  overflowY: "auto",
  overflowX: "hidden"
};

export const styleModalDark = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxWidth: "80%",
  maxHeight: "85vh",
  bgcolor: grayHex,
  boxShadow: 24,
  p: 2,
  borderRadius: "12px",
  overflowY: "auto",
  overflowX: "hidden"
};

export const styleModalFull = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxWidth: "100%",
  maxHeight: "100vh",
  bgcolor: "black",
  padding: "10px",
  borderRadius: "12px",
  overflowY: "auto",
  overflowX: "hidden"
};

export const textfieldStyle = {
  input: {
    border: `2px solid ${grayHex}`,
    background: "transparent",
    borderRadius: "4px",
    color: "white",
    '&:disabled': {
      background: grayHex,
      color: lightgrayHex,
      "-webkit-text-fill-color": "unset"
    }
  },
  placeholder: {
    color: "lightgray",
  },
};

export const textfieldStyleBlack = {
  input: {
    border: `2px solid ${blackHex}`,
    background: blackHex,
    borderRadius: "4px",
    color: "white",
    '&:disabled': {
      background: grayHex,
      color: lightgrayHex,
      "-webkit-text-fill-color": "unset"
    }
  },
  placeholder: {
    color: "lightgray",
  },
};

export const autocompleteStyleBlack = {
  '& .MuiInputBase-root': {
    border: `2px solid ${blackHex}`,
    background: blackHex,
    borderRadius: "4px",
    color: "white",
    '& .MuiAutocomplete-endAdornment': {
      button: {
        color: "white"
      }
    },
    '&.Mui-disabled' : {
      border: `2px solid ${darkGrayHex}`,
      background: darkGrayHex,
      color: lightgrayHex,
      "-webkit-text-fill-color": "unset"
    }
  }
};

export const passwordTextfieldStyle = {
  '& .MuiInputBase-root' : {
    paddingRight: "unset",
  },
  input: {
    borderTop: `2px solid #1D1D24`,
    borderBottom: `2px solid #1D1D24`,
    borderLeft: `2px solid #1D1D24`,
    background: "transparent",
    borderTopLeftRadius: "4px",
    borderBottomLeftRadius: "4px",
    color: "white",
  },
  placeholder: {
    color: "lightgray",
  }
};

export const passwordToggleStyle = {
  borderTop: `2px solid ${grayHex}`,
  borderBottom: `2px solid ${grayHex}`,
  borderRight: `2px solid ${grayHex}`,
  borderTopRightRadius: "4px",
  borderBottomRightRadius: "4px",
  background: "transparent",
  height: "56px",
  maxHeight: "unset",
  marginLeft: "unset",
  paddingLeft: "8px",
  paddingRight: "15px",
}

export const btnStyle = {
  borderRadius: "12px",
  padding: "10px",
  color: "black",
  fontWeight: "bold",
  backgroundColor: "white",
  textTransform: "none",
  '&:hover': {
    backgroundColor: "lightgray"
  }
};

export const btnStyleContrast = {
  borderRadius: "12px",
  padding: "10px",
  color: "white",
  fontWeight: "bold",
  backgroundColor: "black",
  textTransform: "none",
  opacity: 1,
  '&:hover': {
    backgroundColor: lightgrayHex
  },
  '&:disabled': {
    opacity: 0.5,
    color: "white",
  }
};

export const btnStyleContrastGray = {
  borderRadius: "12px",
  padding: "10px",
  color: "white",
  fontWeight: "bold",
  backgroundColor: lightgrayHex,
  textTransform: "none",
  opacity: 1,
  '&:hover': {
    backgroundColor: lightergrayHex
  },
  '&:disabled': {
    opacity: 0.5,
    color: "white",
  }
};

export const btnStyleOutlined = {
  borderRadius: "12px",
  backgroundColor: "transparent",
  border: "1px solid #505862",
  padding: "10px",
  textTransform: "unset",
  color: "white"
};

export const btnStyleText = {
  backgroundColor: "transparent",
  border: "none",
  padding: "10px",
  textTransform: "unset",
  color: "white"
};

export const btnStyleTextContrast = {
  backgroundColor: "transparent",
  border: "none",
  padding: "10px",
  textTransform: "unset",
  color: "black"
};

export const roudedIconButtonStyle = {
  borderRadius: "100px",
  width: { xs: "30px" , md: "40px"},
  height: { xs: "30px" , md: "40px"},
  minWidth: "unset",
  backgroundColor: lightgrayHex,
  color: "white",
  padding: "0px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "none",
  '&:hover': {
    backgroundColor: grayHex
  }
};

export const paginationContrast = { 
  '& .MuiPaginationItem-root': {
    color: 'black', 
  },
  '& .MuiPaginationItem-icon': {
    color: 'black', 
  },
  '& .Mui-selected': {
    backgroundColor: 'black !important', 
    color: 'white', 
  },
};

export const pagination = { 
  '& .MuiPaginationItem-root': {
    color: 'white', 
  },
  '& .MuiPaginationItem-icon': {
    color: 'white', 
  },
  '& .Mui-selected': {
    backgroundColor: 'white !important', 
    color: 'black', 
  },
};

export const methodItemStyle = {
  marginTop: "24px",
  minHeight: "96px",
  height: "auto",
  width: "99%",
  borderRadius: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  "&:hover": {
    bgcolor: "rgba(0, 0, 0, 0.23)",
  },
}

export const radioStyle = {
  color: "white !important",
  '&.Mui-checked': {
    color: "white",
  },
}